module.exports = __webpack_public_path__ + "static/media/0121_IMG_LE_CIEL_DE_BOIS.6a35e372.webp";